import { useState, useCallback } from 'react';
import { distribucionAPI } from '../services/api';

const errorDe = (error, porDefecto) => error.response?.data?.error || porDefecto;

/**
 * Distribución de servicios Cloud: aplicaciones, reglas y los recursos del
 * mes con la regla que les aplica (la resuelve el servidor).
 */
export const useDistribucion = (showNotification) => {
  const [apps, setApps] = useState([]);
  const [reglas, setReglas] = useState([]);
  const [recursos, setRecursos] = useState(null); // { periodo, recursos }
  const [loading, setLoading] = useState(false);

  const loadBase = useCallback(async () => {
    try {
      const [a, r] = await Promise.all([distribucionAPI.getApps(), distribucionAPI.getReglas()]);
      setApps(a.data.apps || []);
      setReglas(r.data.reglas || []);
    } catch (error) {
      console.error('Error cargando distribución:', error);
      showNotification?.('error', 'Distribución', errorDe(error, 'No se pudieron cargar las reglas'));
    }
  }, [showNotification]);

  const loadRecursos = useCallback(async (periodo) => {
    if (!periodo) return;
    setLoading(true);
    try {
      const res = await distribucionAPI.getRecursos(periodo);
      setRecursos(res.data);
    } catch (error) {
      console.error('Error cargando recursos:', error);
      showNotification?.('error', 'Distribución', errorDe(error, 'No se pudieron cargar los recursos'));
    } finally {
      setLoading(false);
    }
  }, [showNotification]);

  // Devuelve true/false; en conflicto (regla igual) avisa y devuelve false.
  const guardarRegla = useCallback(async (id, regla) => {
    try {
      if (id) await distribucionAPI.editarRegla(id, regla);
      else await distribucionAPI.crearRegla(regla);
      return true;
    } catch (error) {
      showNotification?.('error', 'Distribución', errorDe(error, 'No se pudo guardar la regla'));
      return false;
    }
  }, [showNotification]);

  // Devuelve { creadas, omitidas } o null si falla.
  const asignarLote = useCallback(async (recursos) => {
    try {
      const res = await distribucionAPI.asignarLote(recursos);
      return res.data;
    } catch (error) {
      showNotification?.('error', 'Distribución', errorDe(error, 'No se pudieron asignar los recursos'));
      return null;
    }
  }, [showNotification]);

  const eliminarRegla = useCallback(async (id) => {
    try {
      await distribucionAPI.eliminarRegla(id);
      return true;
    } catch (error) {
      showNotification?.('error', 'Distribución', errorDe(error, 'No se pudo eliminar la regla'));
      return false;
    }
  }, [showNotification]);

  return { apps, reglas, recursos, loading, loadBase, loadRecursos, guardarRegla, eliminarRegla, asignarLote };
};
